import React from 'react';

interface StampImageProps {
  count: number;
  size?: number;
  imageUrl?: string;
}

const StampImage: React.FC<StampImageProps> = ({ count, size = 100, imageUrl = '/default-stamp.png' }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        position: 'relative',
        display: 'inline-block',
        margin: 8,
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundImage: `url("${imageUrl}")`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          opacity: count > 0 ? 1 : 0.3,
          filter: count > 0 ? 'none' : 'grayscale(100%)',
        }}
      />
      {count > 1 && (
        <span
          style={{
            position: 'absolute',
            bottom: 5,
            right: 5,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            padding: '2px 6px',
            borderRadius: 12,
            fontSize: '0.8rem',
          }}
        >
          {count}
        </span>
      )}
    </div>
  );
};

export default StampImage;
